import type { PartnershipView, ShareableTree } from "../api/partnership";

export type BreedingPartner = {
  partnershipId: number;
  companyName: string;
  partnershipType: PartnershipView["partnership_type"];
  /** "full" : l'élevage entier est partagé ; "partial" : seulement des bâtiments ou produits. */
  scope: "full" | "partial";
};

/**
 * Partenaires qui ont accès à tout ou partie d'un élevage, d'après l'arbre de partage de
 * chaque partenariat. Un partenariat sans rien de partagé sur cet élevage est écarté.
 */
export const breedingPartners = (
  breedingId: number,
  entries: { partnership: PartnershipView; tree: ShareableTree }[]
): BreedingPartner[] =>
  entries.flatMap(({ partnership, tree }) => {
    const breeding = tree.breedings.find((entry) => entry.id === breedingId);
    if (!breeding) return [];

    const partlyShared = breeding.buildings.some(
      (building) =>
        building.shared || building.devices.some((device) => device.shared)
    );
    if (!breeding.shared && !partlyShared) return [];

    return [
      {
        partnershipId: partnership.id,
        companyName: partnership.company.company_name,
        partnershipType: partnership.partnership_type,
        scope: breeding.shared ? "full" : "partial",
      },
    ];
  });
